import React from "react";

const Info = () => {
  return (
    <div>
      <h2>
        <pre>
          let <span className="variable">contactInfo</span> ={" "}
          <span className="curlyBrace">{"{"}</span> <br />
          {"  "}
          <span className="key">"email"</span>
          {":"}
          <span className="values">
            <a href="mailto:sumanmaharana222888@gmail.com" target="_blank">
            sumanmaharana222888@gmail.com
            </a>
          </span>
          , <br />
          {"  "}
          <span className="key">"phone"</span>
          {":"}
          <span className="values">
            <a href="tel:+917894887909" target="_blank">
              +917894887909
            </a>
          </span>
          , <br />
          {"  "}
          <span className="key">"location"</span>
          {":"}
          <span className="values">"India"</span>, <br />
          {"  "}
          <span className="key">"social"</span>
          {":"}
          <span className="curlyBrace">{"{"}</span>
          <br />
          {"     "}
          <span className="key">"facebook"</span>
          {":"}
          <span className="values">
            <a
              href="https://www.facebook.com/suman.maharana.75/"
              target="_blank"
            >
              "Suman Kumar Maharana"
            </a>
          </span>
          , <br />
          {"     "}
          <span className="key">"instagram"</span>
          {":"}
          <span className="values">
            <a
              href="https://www.instagram.com/i_am_kirraa/"
              target="_blank"
            >
              "_.iamkiraaa._"
            </a>
          </span>
          , <br />
          {"     "}
          <span className="key">"twitter"</span>
          {":"}
          <span className="values">
            <a href="https://twitter.com/sumantheshine" target="_blank">
              "Suman Kumar Maharana"
            </a>
          </span>
          , <br />
          {"     "}
          <span className="key">"whatsApp"</span>
          {":"}
          <span className="values">
            <a href="https://wa.me/+917894887909" target="_blank">
              "7894887909"
            </a>
          </span>
          , <br />
          {"     "}
          <span className="key">"github"</span>
          {":"}
          <span className="values">
            <a href="https://github.com/thisissuman" target="_blank">
              "thisissuman"
            </a>
          </span>
          , <br />
          {"     "}
          <span className="key">"linkedIn"</span>
          {":"}
          <span className="values">
            <a
              href="https://www.linkedin.com/in/sumanmaharana222888/"
              target="_blank"
            >
              "Suman Kumar Maharana"
            </a>
          </span>
          , <br />
          {"     "}
          <span className="key">"codepen"</span>
          {":"}
          <span className="values">
            <a href="https://codepen.io/thisissuman" target="_blank">
              "suman-kumar-maharana"
            </a>
          </span>
          , <br />
          {"  "}
          <span className="curlyBrace">{"  }"}</span>
          <br />
          <span className="curlyBrace">{" }"}</span>
        </pre>
      </h2>
    </div>
  );
};

export default Info;
